import { Row, Col, Table } from "react-bootstrap";

import { tableHead, header_table } from "./createOrder.module.scss";

const CreateOrderTableHead = () => {
	return (
		<Row className={header_table}>
			<Col md={12} sm={12}>
				<Table className={tableHead}>
					<thead>
						<tr>
							<th style={{ width: "30%" }}>
								Producto <br />
								<small>Ingrese al menos 3 letras para buscar.</small>{" "}
							</th>
							<th style={{ width: "15%" }}>Contenido</th>
							<th style={{ width: "15%" }}>U.M.</th>
							<th style={{ width: "15%" }}>Precio Total Neto</th>
							<th style={{ width: "20%" }}>Observaciones</th>
							<th style={{ width: "5%" }}></th>
						</tr>
					</thead>
				</Table>
			</Col>
		</Row>
	);
};

export default CreateOrderTableHead;
